// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CustomLayout, { CustomLayoutStyle } from "@hardwoods/App/Components/Common/CustomLayout";
import { CategoryDetailsPageContext } from "@hardwoods/Overrides/Pages/CategoryDetailsPage";
import { ProductListPageContext } from "@hardwoods/Overrides/Pages/ProductListPage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { FC } from "react";

type Props = WidgetProps;

const style: CustomLayoutStyle = {
    headerContainer: {
        fullWidth: [true, true, true, true, true],
    },
};

const CategoryLayout: FC<Props> = ({ id }) => {
    return <CustomLayout id={id} extendedStyles={style} />;
};

const categoryLayoutWidget: WidgetModule = {
    component: CategoryLayout,
    definition: {
        allowedContexts: [CategoryDetailsPageContext, ProductListPageContext],
        group: "Hardwoods Layout" as any,
        displayName: "Category Layout",
    },
};

export default categoryLayoutWidget;
